var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 256,
    viewBox: "0 0 335 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2485_7716)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258 15H77.9997C75.6358 14.9999 73.295 15.4676 71.1111 16.3762C68.9271 17.2849 66.9427 18.6168 65.2713 20.2958C63.5998 21.9749 62.274 23.9682 61.3695 26.1619C60.4651 28.3557 59.9997 30.7069 60 33.0813V99.4957C60 200.761 145.298 234.359 162.375 240.065C166.022 241.312 169.978 241.312 173.625 240.065C190.725 234.359 276 200.761 276 99.4957V33.0813C276 28.2861 274.104 23.6872 270.728 20.2963C267.353 16.9054 262.774 15.0003 258 15Z",
    fill: "#2C2B30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2485_7716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 15,
    width: 216,
    height: 226
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258 15H77.9997C75.6358 14.9999 73.295 15.4676 71.1111 16.3762C68.9271 17.2849 66.9427 18.6168 65.2713 20.2958C63.5998 21.9749 62.274 23.9682 61.3695 26.1619C60.4651 28.3557 59.9997 30.7069 60 33.0813V99.4957C60 200.761 145.298 234.359 162.375 240.065C166.022 241.312 169.978 241.312 173.625 240.065C190.725 234.359 276 200.761 276 99.4957V33.0813C276 28.2861 274.104 23.6872 270.728 20.2963C267.353 16.9054 262.774 15.0003 258 15Z",
    fill: "#2C2B30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2485_7716)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 97.3394,
    x2: 561,
    y2: 97.3394,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 169.81,
    x2: 561,
    y2: 169.81,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 24.8691,
    x2: 561,
    y2: 24.8691,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 206.045,
    x2: 561,
    y2: 206.045,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 61.104,
    x2: 561,
    y2: 61.104,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11,
    y1: 133.575,
    x2: 561,
    y2: 133.575,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.086,
    y1: -97,
    x2: 249.086,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.994,
    y1: -97,
    x2: 127.994,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.4473,
    y1: -97,
    x2: 67.4472,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.539,
    y1: -97,
    x2: 188.539,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.266,
    y1: -97,
    x2: 158.266,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.7207,
    y1: -97,
    x2: 97.7206,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.812,
    y1: -97,
    x2: 218.812,
    y2: 365,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.15 206.393H179.909L184.45 210.733L188.423 214.696V242.628H158.15V206.393Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.809 206.643L184.277 210.914L188.174 214.8V242.378H158.4V206.643H179.809Z",
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.0098,
    y: -50.7793,
    width: 500.14,
    height: 275.039,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6426 -11.2847H119.401L123.942 -6.94398L127.916 -2.98075V24.9506H97.6426V-11.2847Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3711 61.5635H89.1298L93.6708 65.9042L97.6441 69.8674V97.7988H67.3711V61.5635Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 61H240.759L245.3 65.3407L249.273 69.3039V97.2353H219V61Z",
    fill: "#242426"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 100,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#242426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M187.799 108.201C182.763 103.165 175.998 100.238 168.879 100.014C161.761 99.7901 154.825 102.287 149.483 106.997L168 128L187.799 108.201Z",
    fill: "url(#paint0_linear_2485_7716)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.798 108.201C182.762 103.165 175.997 100.238 168.879 100.014C161.76 99.7901 154.824 102.287 149.482 106.997",
    stroke: "url(#paint1_linear_2485_7716)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 137C172.747 137 177 132.747 177 127.5C177 122.253 172.747 118 167.5 118C162.253 118 158 122.253 158 127.5C158 132.747 162.253 137 167.5 137Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178 138L176 136",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2485_7716",
    x1: 168,
    y1: 128,
    x2: 168,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2485_7716",
    x1: 187.798,
    y1: 104.101,
    x2: 149.482,
    y2: 104.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44CCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2485_7716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 226,
    fill: "white",
    transform: "translate(60 14.9995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep2);
export default __webpack_public_path__ + "static/media/MobileStep2.5aaa48407f280a003e2213470d07f29e.svg";
export { ForwardRef as ReactComponent };